<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <span class="login-title">
                <img src="../../assets/liberdade.png" width="250px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <!-- INSCRIÇÃO DOS CULTOS -->
                    <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: linear-gradient(to right, #00BFA5, #80CBC4)">
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                            <v-card-title class="text-h6">Cultos</v-card-title>
                            <v-card-subtitle></v-card-subtitle>
                            <v-card-actions>
                              <router-link to="/liberdade" style="text-decoration: none">
                                <v-btn class="ml-2 mb-2" height="40px" outlined right width="140px">Inscrever-se</v-btn>
                              </router-link>
                            </v-card-actions>
                          </div>
                          <v-avatar class="ma-3" size="125" tile>
                            <v-img :src="imagemLiberdade"></v-img>
                          </v-avatar>
                        </div>
                      </v-card>
                    </v-col>
                    <!-- INSCRIÇÃO DO KIDS -->
                    <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: linear-gradient(to right, #e45f50, #ef9c74)">
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                            <v-card-title class="text-h6">Liberty Kids</v-card-title>
                            <v-card-subtitle></v-card-subtitle>
                            <v-card-actions>
                              <router-link to="/kids" style="text-decoration: none">
                                <v-btn class="ml-2 mb-2" height="40px" outlined right width="140px">Inscrever-se</v-btn>
                              </router-link>
                            </v-card-actions>
                          </div>
                          <v-avatar class="ma-3" size="125" tile>
                            <v-img :src="imagemKids"></v-img>
                          </v-avatar>
                        </div>
                      </v-card>
                    </v-col>
                    <!-- INSCRIÇÃO DO LIBERTY CONFERENCE -->
                    <!-- <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: linear-gradient(to right, #424242, #616161)">
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                            <v-card-title class="text-h6">Liberty Conference 2021</v-card-title>
                            <v-card-subtitle></v-card-subtitle>
                            <v-card-actions>
                              <router-link to="/libertyconference21" style="text-decoration: none">
                                <v-btn class="ml-2 mb-2" height="40px" outlined right width="140px">Inscrever-se</v-btn>
                              </router-link>
                            </v-card-actions>
                          </div>
                          <v-avatar class="ma-3" size="125" tile>
                            <v-img :src="imagemLiberty"></v-img>
                          </v-avatar>
                        </div>
                      </v-card>
                    </v-col> -->
                    <!-- INSCRIÇÃO DO VALENTES -->
                    <!-- <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: linear-gradient(to right, #212121, #808080)">
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                            <v-card-title class="text-h6">Congresso Valentes 2021</v-card-title>
                            <v-card-subtitle></v-card-subtitle>
                            <v-card-actions>
                              <router-link to="/valentes" style="text-decoration: none">
                                <v-btn class="ml-2 mb-2" height="40px" outlined right width="140px">Inscrever-se</v-btn>
                              </router-link>
                            </v-card-actions>
                          </div>
                          <v-avatar class="ma-3" size="125" tile>
                            <v-img :src="imagemValentes"></v-img>
                          </v-avatar>
                        </div>
                      </v-card>
                    </v-col> -->
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoAIPassIntelite.png" width="250px">
          </a>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
  // import { baseApiUrl } from '@/global'
  import { mapState } from 'vuex'
  export default {
    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),

    data: function () {
      return {
        imagemLiberdade: require('../../assets/logoLiberdade.png'),
        imagemKids: require('../../assets/kids.jpeg'),
        imagemLiberty: require('../../assets/conference2021.png'),
        imagemValentes: require('../../assets/valentes.png'),
      }
    },

    mounted: function () {
      this.$validator.localize('pt', this.dictionary)
    },

    methods: {
      
    }
  }
</script>

<style scoped>
  /* LOGIN */

  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #4A148C, #8E24AA);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }
</style>